import { render, staticRenderFns } from "./ReportAdmin.vue?vue&type=template&id=166c40d6&scoped=true&"
import script from "./ReportAdmin.vue?vue&type=script&lang=js&"
export * from "./ReportAdmin.vue?vue&type=script&lang=js&"
import style0 from "./ReportAdmin.vue?vue&type=style&index=0&id=166c40d6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "166c40d6",
  null
  
)

export default component.exports